export default __webpack_public_path__ + "static/media/GH.a6da8dd2.svg";